import { FileTransferFeature, useUploadFile } from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';

export function useUploadPhoto() {
  const { t } = useTranslation(['common']);

  return useUploadFile({
    documentType: FileTransferFeature.NoticeboardPhoto,
    additionalFormValues: {
      overwrite: 'false',
    },
    mutationOptions: {
      onError: () => {
        toast.success(t('common:snackbarMessages.errorFailed'));
      },
    },
  });
}
